module.exports = __webpack_public_path__ + "img/gallery-cookie-cover.b801f398.png";